// src/middleware/axios-policy.ts
import * as API from '@/utils/api';

export type SuccessToastOverride = boolean | undefined;

const INTERACT_SUCCESS_PATHS = [
  // subpass
  API.CREATE_SUBPASS,

  // USER
  API.USERS_ACTIVATE,
  API.UPDATE_PROFILE,
  API.RESET_PASSWORD,
  API.UPDATE_COMMISSION,
  API.USERS_CREATE,
  API.UPDATE_SHOW_CURRENCY_SIGNS,
  API.CHECK_PREFIX,

  // GAME
  API.EDIT_DEMO_URL,
  API.GAME_MAINTENANCE,
  API.MAINTENANCE_ALL_SOCKET,
  API.MAINTENANCE_GAMES_SOCKET,
  API.GAME_VERSION,

  // VERSION
  API.EDIT_TRANSACTION,
  API.EDIT_VERSION_MASCOT,

  // PERMISSION
  API.UPDATE_PERMISSION,

  // PARTNER
  API.UPDATE_TRANSFER_KEY,
  API.UPDATE_SEAMLESS_KEY,

  // WALLET
  API.TRANSFER,
  API.WITHDRAW,

  // INVITE FRIEND
  API.INVITE_FRIEND_EDIT,

  // SUGGESTION
  API.SUGGESTION_CREATE_TOPIC,
  API.SUGGESTION_EDIT_TOPIC,
  API.SUGGESTION_DELETE_TOPIC,
  API.SUGGESTION_SUBMIT,

  // ANNOUNCEMENT
  API.ANNOUNCEMENT_CREATE,
  API.ANNOUNCEMENT_UPDATE,
  API.ANNOUNCEMENT_DELETE,

  // AGENT BANNER
  API.AGENT_BANNER_CREATE,
  API.AGENT_BANNER_UPDATE,
  API.AGENT_BANNER_DELETE,

  // BANK ACCOUNT
  API.BANKACCOUNT_CREATE,
  API.BANKACCOUNT_UPDATE,
  API.BANKACCOUNT_DELETE,

  // SOCIAL
  API.SOCIAL_EDIT,

  // PROMOTION
  API.PROMOTION_CREATE,
  API.PROMOTION_UPDATE,
  API.PROMOTION_DELETE,

  // DOCUMENT / INVOICE
  API.DOCUMENT_CREATE,
  API.DOCUMENT_DELETE,

  // ADMIN
  API.RESET_SUBPASS,
  API.USER_SEAMLESS_PROBLEM_ADD,
  API.USER_SEAMLESS_PROBLEM_REMOVE,

  // MARKETING
  API.UPDATE_FEATURE_MASCOT,
  API.UPDATE_AGENT_MASCOT,
  API.UPDATE_FEATURE_ANGPOW,

  // SETTING
  API.SETTING_UPDATE,

  // WHITE LABEL
  API.EDIT_IMAGE,
  API.EDIT_THEME,
  API.UPLOAD_IMAGE,
  API.UPDATE_THEME,

  // RTP
  API.UPDATE_RTP,
  API.UPDATE_AGENT_RTP,

  // MECHANIC
  API.SET_PATTERN_MAINTENANCE,

  // RISK MANAGEMENT
  API.UPDATE_CONFIGS_RISK,

  // DOMAIN POOL
  API.DOMAIN_POOL_ADD,
  API.DOMAIN_POOL_UPDATE,

  // Campaign
  API.CAMPAIGN_ADD
] as const;

const INTERACT_SUCCESS_EXACT_PATHS = new Set<string>(INTERACT_SUCCESS_PATHS.filter(path => !path.endsWith('/')));

const INTERACT_SUCCESS_PREFIX_PATHS: string[] = INTERACT_SUCCESS_PATHS.filter(path => path.endsWith('/'));

export const getPath = (url?: string) => {
  if (!url) return '';

  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url.split('/').slice(3).join('/');
  }

  return url.replace(/^\/+/, '');
};

const matchesPolicyPath = (requestPath: string, policyPath: string) => {
  if (!requestPath || !policyPath) return false;

  if (requestPath === policyPath) return true;

  if (policyPath.endsWith('/')) {
    return requestPath.startsWith(policyPath);
  }

  return false;
};

export const shouldShowSuccessNotificationByPolicy = (url?: string) => {
  const path = getPath(url);
  if (!path) return false;

  if (INTERACT_SUCCESS_EXACT_PATHS.has(path)) {
    return true;
  }

  return INTERACT_SUCCESS_PREFIX_PATHS.some(policyPath => matchesPolicyPath(path, policyPath));
};

export const resolveSuccessNotification = (url?: string, override?: SuccessToastOverride) => {
  if (typeof override === 'boolean') {
    return override;
  }

  return shouldShowSuccessNotificationByPolicy(url);
};

export { INTERACT_SUCCESS_PATHS, INTERACT_SUCCESS_EXACT_PATHS, INTERACT_SUCCESS_PREFIX_PATHS };
